export default __webpack_public_path__ + "static/media/cbs.8ea4f65b.jpg";